import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useEmailField } from '../../hooks/useEmailField';

interface EmailAddressInputInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  submitting?: boolean;
}

export default function EmailAddressInputInput({
  value,
  onChange,
  disabled,
  submitting,
}: EmailAddressInputInputProps) {
  const { t } = useTranslation();
  // Required field: normalizes to lower case while typing and validates the address.
  const { fieldProps } = useEmailField({
    value,
    onChange,
    required: true,
    submitting,
    disabled,
  });

  return (
    <TextField
      label={`${t('formInputs.emailAddressInputLabel')} *`}
      variant='outlined'
      fullWidth
      disabled={disabled}
      {...fieldProps}
    />
  );
}
